import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Select, Typography } from "@arco-design/web-react";
import { FetchApi } from "../../Api/AuthenticatedApi";

const { Text } = Typography;

// placeName is how a picked place reads: "Denver, Colorado, United States".
export const placeName = (p) => [p.name, p.admin1_name, p.country_name].filter(Boolean).join(", ");

// PlacePicker finds a place as you type ("Denver", or "Denver, CO" /
// "Paris, France" to narrow it) and hands back { id, name, lat, lng }.
export default function PlacePicker({ value, onChange }) {
  const { getAccessTokenSilently } = useAuth0();
  const [places, setPlaces] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const timer = React.useRef();

  const search = (q) => {
    clearTimeout(timer.current);
    if (!q || !q.trim()) return;
    timer.current = setTimeout(() => {
      setLoading(true);
      FetchApi(getAccessTokenSilently, "/api/geo/places?" + new URLSearchParams({ q, limit: 10 }),
        (d) => { setPlaces(d || []); setLoading(false); },
        () => setLoading(false),
        () => setLoading(false));
    }, 250);
  };
  React.useEffect(() => () => clearTimeout(timer.current), []);

  // The picked place stays a choice even after new results come in.
  const choices = [...places];
  if (value && !choices.some((p) => p.id === value.id)) choices.unshift({ id: value.id, name: value.name, picked: true });

  return (
    <Select
      size="small"
      showSearch
      allowClear
      aria-label="Place"
      placeholder="Type a city"
      style={{ minWidth: 220, flex: 1 }}
      loading={loading}
      filterOption={false}
      value={value ? value.id : undefined}
      onSearch={search}
      onChange={(id) => {
        const p = choices.find((x) => x.id === id);
        onChange(p ? { id: p.id, name: p.picked ? p.name : placeName(p), lat: p.picked ? value.lat : p.lat, lng: p.picked ? value.lng : p.lng } : null);
      }}
      notFoundContent={<Text type="secondary" style={{ padding: 8, display: "block" }}>Type a city to search</Text>}
      dropdownRender={(menu) => (
        <div>
          {menu}
          <Text type="secondary" style={{ display: "block", fontSize: 11, padding: "4px 12px" }}>
            Places from GeoNames (CC BY 4.0)
          </Text>
        </div>
      )}
      options={choices.map((p) => ({ value: p.id, label: p.picked ? p.name : placeName(p) }))}
    />
  );
}
